<template>
  <div class="row justify-content-center">
    <div v-if="forget===false" class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>Inicia sesion con sus credenciales</small>
          </div>
          <form role="form">
            <base-input class="input-group-alternative mb-3"
                        placeholder="Email"
                        addon-left-icon="ni ni-email-83"
                        v-model="model.email">
            </base-input>

            <base-input class="input-group-alternative"
                        placeholder="Contraseña"
                        type="password"
                        addon-left-icon="ni ni-lock-circle-open"
                        v-model="model.password">
            </base-input>

            <base-checkbox class="custom-control-alternative">
              <span class="text-muted">Recordarme</span>
            </base-checkbox>
            <div class="text-center">
              <base-button type="default" @click="login" class="my-4">Ingresar</base-button>
            </div>
            <base-alert type="danger" v-if="error">
              <strong>{{ error }}</strong>
            </base-alert>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a @click="changeforget" class="text-light"><small>Olvido la contraseña?</small></a>
        </div>
      </div>
    </div>
    <div v-if="forget===true" class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>Recuperar Contraseña</small>
          </div>
          <form role="form">
            <base-input class="input-group-alternative mb-3"
                        placeholder="Email"
                        addon-left-icon="ni ni-email-83"
                        v-model="model.email">
            </base-input>
            <div class="text-center">
              <base-button type="default" @click="Recuperar" class="my-4">Recuperar</base-button>
            </div>
            <base-alert type="success" v-if="recovery">
              <strong>{{ recovery }}</strong>
            </base-alert>
            <base-alert type="danger" v-if="error">
              <strong>{{ error }}</strong>
            </base-alert>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a @click="changeforget" class="text-light"><small>Volver al inicio</small></a>
        </div>
      </div>
    </div>

    <div class="content-loading" id="content-loading">
      <div class="img-loading"></div>
    </div>
  </div>
</template>
<script>
import {bus} from '../components/Login/bus-login'
import {login_service} from '../services/login/LoginService'

export default {
  name: 'login',
  data() {
    return {
      forget: false,
      error: '',
      recovery: '',
      model: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    changeforget() {
      this.forget = !this.forget
    },
    login() {
      this.error = ''
      if (this.model.email && this.model.password) {
        document.getElementById("content-loading").classList.add("active");
        login_service.login(this.model)
      } else {
        this.error = 'Los campos no pueden estar vacios'
      }

    },
    Recuperar() {
      if (this.model.email) {
        login_service.RessetPass(this.model.email)
      } else {
        this.error = 'El correo no pueden estar vacio'
      }
    }
  },
  created() {
    bus.$on('login', (response) => {
      if (response.accessToken) {
        login_service.vallogin()
      } else {
        this.error = 'Los datos ingresados son incorrectos'
        document.getElementById("content-loading").classList.add("inactive");
      }
    })
    bus.$on('errorlogin', (response) => {
      this.error = response
    })
    bus.$on('responseressetpass', (response) => {
      if (response.data.success === true) {
        this.recovery =
            'Se ha enviado un correo electronico con una nueva contraseña.'

      } else {
        this.recovery =
            'No hemos encontrado ningun registro con este correo.'

      }
    })
  }
}
</script>
<style scope>

body {
  height: 100vh;
}

@media screen and (min-width: 1001px) and (max-width: 11440px) {
  body .login-header > div.container {
    position: absolute;
    top: 10vh;
    left: 0;
    right: 0;
    bottom: auto;
  }

  body .main-content.bg-default {
    height: 100vh;
    overflow: auto;
  }

  body .container.mt--8.pb-5 .row.justify-content-center {
    margin-top: 5%;
  }

  footer {
    display: none;
  }
}

@media screen and (min-width: 300px) and (max-width: 1001px) {
  .px-4.container button {
    display: none;
  }

  .px-4.container a {
    margin: 0 auto;
  }
}
</style>
